/**
 * Lawyer Availability page
 * Uses shared AvailabilitySearch component
 */
import { createRoute } from '@tanstack/react-router'
import { lawyerRoute } from './index'
import { AvailabilitySearch } from '@/components/amadeus'

function AvailabilityPage() {
  return (
    <div className="h-full flex flex-col p-6 lg:p-8">
      <AvailabilitySearch seatmapPath="/lawyer/seatmap" />
    </div>
  )
}

export const lawyerAvailabilityRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/availability',
  component: AvailabilityPage,
})
